import { FC, useEffect, useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Col, DropdownItem, Label, Modal, ModalBody, ModalFooter, ModalHeader, Offcanvas, OffcanvasBody, OffcanvasHeader, Row } from "reactstrap";
import colors from "../config/Colors.config";
import { Badge, IconButton, } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Sidebar, Menu, MenuItem, SubMenu,/* SubMenu*/ } from 'react-pro-sidebar';
import { Groups, Home as IconHome, Logout, List, PersonAddAltRounded, Close, GppMaybe, NoEncryption } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from "react-router-dom";
import Block from "../components/Block.component";
import Usuario from "../interfaces/Usuario.interface";
import UsuarioModel from "../models/Usuario.model";
import TiempoTool from "../tools/Tiempo.tool";
import HomeView from "./Home.index";
import UsuarioBuscar from "./ClientesBuscar.view";
import { useSearchParams } from "react-router-dom";


import imgLogo from "../assets/img/logo.png";
import imgLogoUser from "../assets/svg/userLogo.svg";

import "../assets/css/style.css";
import ClienteAgregar from "./ClienteAgregar.view";
import Device from "../interfaces/Device.interface";
import DeviceConfig from "../config/Device.config";

const DashboardView: FC = () => {

    const [data] = useState<Device>(DeviceConfig.data());

    const [collapsed, setCollapsed] = useState<boolean>(true);

    const [isHovered, setIsHovered] = useState({ 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 17: false });

    const [usuario, setUsuario] = useState<Usuario>(UsuarioModel.getEstructura());
    const [indexPage, setIndexPage] = useState<number>(0);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openMenu, setOpenMenu] = useState<boolean>(false);
    const [openAcordion, setOpenAcordion] = useState<string>('');
    const [searchParams] = useSearchParams();



    // const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        usuarioCargar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cargarURL = (): void => {

        const newIndex: number = Number(searchParams.get("page"));
        changeIndexPage(newIndex);
    }

    const toggle = (id: string) => {
        setOpenAcordion(openAcordion === id ? "" : id);

    };

    const handleMouseEnter = (index: number): void => {
        setIsHovered((prev) => ({ ...prev, [index]: true }));
    };

    const handleMouseLeave = (index: number): void => {
        setIsHovered((prev) => ({ ...prev, [index]: false }));
    };

    const changeIndexPage = (newIndex: number, vIdCliente: number | undefined = undefined): void => {
        setIndexPage(newIndex);
        if (newIndex === 1) {
            if (vIdCliente === undefined) {
                // let IdCliente: number = 0;
                // IdCliente = Number(searchParams.get("cliente")) ?? 0;
            }
        } else {
            navigate(`/dashboard/?page=${newIndex}`);
        }

    };

    const logOut = (): void => {
        UsuarioModel.cookieRemove();
        window.location.href = "/";
    };

    const usuarioCargar = async (): Promise<void> => {

        const usuario: Usuario = await UsuarioModel.cookie();

        if (!(usuario.IdUsuario === 0)) {
            setUsuario(usuario);
            cargarURL();
        } else {
            document.body.innerHTML = '<div></div>'
            setOpenModal(true);
        }

    };

    return (
        <>
            <section style={{ width: "100%", minHeight: "100vh", height: "auto", maxHeight: "auto", backgroundColor: colors.blanco }} >
                {
                    data.isDesktop &&
                    <>
                        <Sidebar style={{ backgroundColor: colors.secundario, color: colors.blanco, height: "100vh", fontWeight: "bold", position: "fixed", width: collapsed ? 0 : 200, zIndex: 3, }} collapsed={collapsed} >
                            <Menu style={{ backgroundColor: colors.secundario, marginTop: 0, height: "100%" }} >
                                <Block height={10} />
                                <Row style={{ marginTop: 0, marginBottom: 10, marginLeft: 0, marginRight: 0, }} >
                                    <Col style={{ textAlign: collapsed ? "center" : "center" }} >
                                        <img
                                            src={collapsed ? imgLogo : imgLogo} alt="no ndata"
                                            style={{ height: 70, marginLeft: collapsed ? -7 : -7, cursor: "pointer", transition: "all 0.4s ease", opacity: collapsed ? 0.9 : 1, transform: collapsed ? "scale(0.9)" : "scale(1)", }}
                                            onClick={() => { setCollapsed(!collapsed) }}
                                        />
                                    </Col>
                                </Row>

                                <MenuItem style={{ color: isHovered[0] ? colors.secundario : colors.blanco }} onMouseEnter={() => handleMouseEnter(0)} onMouseLeave={() => handleMouseLeave(0)} icon={<IconHome />} onClick={() => changeIndexPage(0)} > Inicio </MenuItem>
                                <SubMenu style={{ color: isHovered[1] ? colors.secundario : colors.blanco, }} onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={() => handleMouseLeave(1)} icon={<Groups />} label="Clientes" >
                                    <MenuItem style={{ border: isHovered[2] ? `1.5px solid ${colors.primario}` : 'none', color: isHovered[2] ? colors.primario : colors.blanco, backgroundColor: isHovered[2] ? colors.blanco : colors.secundario }} onMouseEnter={() => handleMouseEnter(2)} onMouseLeave={() => handleMouseLeave(2)} icon={<PersonAddAltRounded />} onClick={() => changeIndexPage(1)} > Agregar </MenuItem>
                                    <MenuItem style={{ border: isHovered[4] ? `1.5px solid ${colors.primario}` : 'none', color: isHovered[4] ? colors.primario : colors.blanco, backgroundColor: isHovered[4] ? colors.blanco : colors.secundario }} onMouseEnter={() => handleMouseEnter(4)} onMouseLeave={() => handleMouseLeave(4)} icon={<List />} onClick={() => changeIndexPage(2)} > Listar </MenuItem>
                                </SubMenu>
                                <MenuItem style={{ color: isHovered[3] ? colors.secundario : colors.blanco }} onMouseEnter={() => handleMouseEnter(3)} onMouseLeave={() => handleMouseLeave(3)} icon={<Logout />} onClick={() => logOut()} > Salir </MenuItem>
                            </Menu>
                        </Sidebar>

                        <Row style={{ marginRight: 0, marginLeft: 0, backgroundColor: colors.blanco, height: "10vh", width: "100%" }} >

                            <Col style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: "1rem" }} >

                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginRight: 15 }} >
                                    <IconButton style={{ backgroundColor: colors.blanco }} >
                                        <Badge badgeContent={0} color="error">
                                            <NotificationsIcon style={{ color: colors.amariyo }} />
                                        </Badge>
                                    </IconButton>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "10px", }} >

                                    <div style={{ textAlign: "right" }}>
                                        <Label style={{ display: "block", fontWeight: "bold", margin: 0, color: colors.secundario }}>
                                            {usuario.nombreCompleto}
                                        </Label>
                                        <Label style={{ display: "block", margin: 0, color: colors.secundario }}>
                                            {usuario.username}
                                        </Label>
                                    </div>

                                    <img
                                        src={imgLogoUser}
                                        alt="No data"
                                        style={{ height: "8vh", width: "8vh", borderRadius: "50%", objectFit: "cover", }}
                                    />

                                </div>

                            </Col>
                        </Row>
                        <Block height={1} backgroundColor={colors.secundario} />

                    </>

                }
                {
                    data.isMovil &&
                    <>
                        <Row style={{ marginRight: 0, marginLeft: 0, backgroundColor: colors.secundario }}>
                            <Col style={{ textAlign: "left", maxWidth: "10%" }} >
                                <Button
                                    style={{ boxShadow: "none", backgroundColor: colors.secundario, marginTop: 5, marginBottom: 5, borderColor: colors.secundario }}
                                    onClick={() => {
                                        setOpenMenu(!openMenu);
                                    }}
                                >
                                    <MenuIcon />
                                </Button>
                            </Col>
                            <Col style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: "1rem", maxWidth: "90%" }} >

                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginRight: 15 }} >
                                    <IconButton style={{ backgroundColor: colors.secundario, marginTop: 6 }} >
                                        <Badge badgeContent={1} color="error">
                                            <NotificationsIcon style={{ color: colors.blanco }} />
                                        </Badge>
                                    </IconButton>
                                </div>

                                {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", }} >

                                    <div style={{ textAlign: "right" }}>
                                        <Label style={{ display: "block", fontWeight: "bold", margin: 0, color: colors.blanco }}>
                                            {usuario.nombreCompleto}
                                        </Label>
                                        <Label style={{ display: "block", margin: 0, color: colors.blanco }}>
                                            {usuario.username}
                                        </Label>
                                    </div>

                                    <img
                                        src={imgLogoUser}
                                        alt="No data"
                                        style={{ height: "8vh", width: "8vh", borderRadius: "50%", objectFit: "cover", }}
                                    />

                                </div> */}

                            </Col>
                        </Row>
                        <Offcanvas isOpen={openMenu}  >
                            <OffcanvasHeader style={{ display: "flex", justifyContent: "flex-start", backgroundColor: colors.secundario, height: 50 }} >
                                <IconButton
                                    style={{ color: colors.blanco }}
                                    onClick={() => {
                                        setOpenMenu(!openMenu);
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            </OffcanvasHeader>
                            <OffcanvasBody style={{ padding: 0 }} >
                                <Accordion open={openAcordion} toggle={toggle} style={{ width: "100%", }} className="custom-accordion">
                                    <AccordionItem>
                                        <Button
                                            targetId="3"
                                            style={{ boxShadow: "none", backgroundColor: colors.blanco, borderColor: colors.blanco, width: "100%", textAlign: "left" }}
                                            onClick={() => {
                                                changeIndexPage(0);
                                                setOpenMenu(!openMenu)
                                            }}
                                        >
                                            <Label style={{ fontWeight: "bold", color: colors.secundario, marginLeft: 10 }} > <IconHome /> Inicio</Label>
                                        </Button>
                                    </AccordionItem>
                                    <AccordionItem className="custom-accordion" >
                                        <AccordionHeader targetId="2"><Label style={{ fontWeight: "bold", color: colors.secundario }} ><Groups />  Clientes</Label></AccordionHeader>
                                        <AccordionBody accordionId="2" style={{ padding: 0 }} >
                                            <DropdownItem divider />
                                            <Row>
                                                <Col>
                                                    <Button
                                                        style={{ boxShadow: "none", backgroundColor: colors.blanco, borderColor: colors.blanco, width: "100%", textAlign: "left", color: colors.secundario }}
                                                        onClick={() => {
                                                            changeIndexPage(1);
                                                            setOpenMenu(!openMenu);
                                                        }}
                                                    >
                                                        <PersonAddAltRounded /> Agregar
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <DropdownItem divider />
                                            <Row>
                                                <Col>
                                                    <Button
                                                        style={{ boxShadow: "none", backgroundColor: colors.blanco, borderColor: colors.blanco, width: "100%", textAlign: "left", color: colors.secundario }}
                                                        onClick={() => {
                                                            changeIndexPage(2);
                                                            setOpenMenu(!openMenu);
                                                        }}
                                                    >
                                                        <List /> Listar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </AccordionBody>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <Button
                                            targetId="3"
                                            style={{ boxShadow: "none", backgroundColor: colors.blanco, borderColor: colors.blanco, width: "100%", textAlign: "left" }}
                                            onClick={() => logOut()}
                                        >
                                            <Label style={{ fontWeight: "bold", color: colors.secundario, marginLeft: 10 }} > <Logout /> Salir</Label>
                                        </Button>

                                    </AccordionItem>
                                </Accordion>
                            </OffcanvasBody>
                        </Offcanvas>
                    </>
                }
                <div onClick={() => { setCollapsed(true) }} >
                    {indexPage === 0 && <HomeView usuario={usuario} />}
                    {indexPage === 1 && <ClienteAgregar usuario={usuario} />}
                    {indexPage === 2 && <UsuarioBuscar changeIndexPage={changeIndexPage} usuario={usuario} />}
                </div>
            </section >

            <Modal
                isOpen={openModal}
                onOpened={() => {
                    TiempoTool.sleep(100).then(() => {
                        window.location.href = "/";
                    });
                }}
                centered
            // size={}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                // close={
                //     <Col style={{ textAlign: "right" }} >
                //         <IconButton
                //             style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                //             onClick={() => setOpenModalLogin(false)}
                //         >
                //             <Close />
                //         </IconButton>
                //     </Col>
                // }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <GppMaybe style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Acceso denegado
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <center>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                            <Col  >
                                <div style={{ height: 70, width: 70, backgroundColor: "#FCEDED", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                    <NoEncryption style={{ height: 50, width: 50, color: "#D83F37" }} />
                                </div>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 16 }} >
                            <Col style={{ textAlign: "center" }} >
                                <Label style={{ fontWeight: "bold" }} >
                                    Control de acceso
                                </Label>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 14 }} >
                            <Col style={{ textAlign: "center" }} >
                                <p>
                                    No tienes persmiso para acceder a esta seccion
                                    o el recurso solicitado no existe
                                </p>
                            </Col>
                        </Row>
                    </center>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ boxShadow: "none", backgroundColor: colors.secundario, fontSize: 14 }}
                        onClick={() => {
                            window.location.href = "/";
                        }}
                    >
                        <Logout /> Ir al LogIn
                    </Button>
                </ModalFooter>
            </Modal >

        </>
    );
};

export default DashboardView;